export const getGlobalSettings = (state: any) => state.globalSettings.data;
export const getGlobalSettingsLoading = (state: any) =>
  state.globalSettings.loading;
export const getGlobalSettingsError = (state: any) =>
  state.globalSettings.error;
